/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TrainingMainGroupDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: TrainingMainGroupDefinitionDto.source;
    name?: string;
    description?: string;
    label?: string;
}

export namespace TrainingMainGroupDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
